// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","stageTag":"stage-tag_stageTag__IlgBz"};